import { Stack, Typography } from '@mui/material'
import COLORS from '../../../styles/colors'
import { HLO } from '../../../types/global'
import formatReadingDate from '../../../util/formatReadingDate'
import { useTranslation } from 'next-i18next'
import { MAX_NUMBER_OF_RESERVATIONS } from '../../../constants/settings'
export type ReadingPlanStatusProps = {
  expireDate: Date | undefined
  hasNoReadingPlan: boolean
  isExpired: boolean
  language: HLO.Language
  remainingReadings: number
  numberOfReservations: number
}

const ReadingPlanStatus = ({
  expireDate,
  hasNoReadingPlan,
  isExpired,
  language,
  remainingReadings,
  numberOfReservations,
}: ReadingPlanStatusProps) => {
  const { t } = useTranslation('HeaderMenu')
  const topFontStyle = {
    color: COLORS.greyDark,
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '100%',
    letterSpacing: '-0.02em',
  }

  const bottomFontStyle = {
    color: COLORS.grey,
    fontWeight: 500,
    fontSize: '10px',
    lineHeight: '100%',
    textAlign: 'right',
    letterSpacing: '-0.02em',
  }

  if (hasNoReadingPlan === true) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        border={`1px solid ${COLORS.burnedOrange}`}
        height="40px"
        textTransform="uppercase"
        width="232px"
      >
        <Typography color={COLORS.burnedOrange} variant="inter_h4">
          {t('no reading plan')}
        </Typography>
      </Stack>
    )
  }

  if (isExpired === true) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        border={`1px solid ${COLORS.burnedOrange}`}
        height="40px"
        textTransform="uppercase"
        width="280px"
      >
        <Typography color={COLORS.burnedOrange} variant="inter_h4">
          {t('reading plan expired')}
        </Typography>
      </Stack>
    )
  }

  return (
    <Stack direction="row" spacing="24px">
      {numberOfReservations !== undefined && (
        <Stack
          alignItems="flex-start"
          direction="column"
          spacing="4px"
          tabIndex={0}
          aria-label={`${numberOfReservations} ${t('reservations')}`}
        >
          <Typography sx={topFontStyle} component="span" aria-disabled="true">
            {`${numberOfReservations}/${MAX_NUMBER_OF_RESERVATIONS}`}
          </Typography>
          <Typography
            sx={bottomFontStyle}
            component="span"
            aria-disabled="true"
          >
            {t('reservations')}
          </Typography>
        </Stack>
      )}
      {remainingReadings !== undefined && (
        <Stack
          alignItems="flex-start"
          direction="column"
          spacing="4px"
          tabIndex={0}
          aria-label={`${remainingReadings} READINGS REMAINING`}
        >
          <Typography sx={topFontStyle} component="span" aria-disabled="true">
            {remainingReadings} {t('readings')}
          </Typography>
          <Typography
            sx={bottomFontStyle}
            component="span"
            aria-disabled="true"
          >
            {t('remaining')}
          </Typography>
        </Stack>
      )}
      {expireDate && (
        <Stack
          alignItems="flex-start"
          direction="column"
          spacing="4px"
          tabIndex={0}
          aria-label={`${t('plan expires').toUpperCase()}:${formatReadingDate(
            language.isocode,
            expireDate,
            true,
          )}`}
        >
          <Typography sx={topFontStyle}>
            {formatReadingDate(language.isocode, expireDate, true)}
          </Typography>
          <Typography sx={bottomFontStyle}>
            {t('plan expires').toUpperCase()}
          </Typography>
        </Stack>
      )}
    </Stack>
  )
}

export default ReadingPlanStatus
